/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { AbstractGridInputCellEditorComponent, CellParams } from '@gh/core-ui-grid';
import { Column, ICellEditorParams, IRowNode } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'gh-gantt-predecessor-cell-editor',
  templateUrl: 'gantt-predecessor-cell-editor.component.html',
  styleUrls: ['gantt-predecessor-cell-editor.component.scss'],
})
export class GridPredecessorCellEditorComponent extends AbstractGridInputCellEditorComponent {
  private node: IRowNode;
  private column: Column;
  private data: any;
  private _onEditorOpen: ProcedureFn<CellParams>;

  agInit(params: ICellEditorParams): void {
    super.agInit(params);

    this.node = params.node;
    this.column = params.column!;
    this.data = params.node.data;
    this._onEditorOpen = params['onEditorOpen'];
  }

  onEditorOpen(): void {
    this._onEditorOpen({ node: this.node, colDef: this.column.getColDef(), data: this.data });
  }
}
